import { DirectionalButtons } from '../../DirectionalButtons';
import { WowBoiLogo } from '../../WowBoiLogo';
import { Screen } from '../../Screen';
import { useAppSelector } from '../../../Redux/store';
import { OptionButtons } from '../../OptionButtons';
import { ActionButtons } from '../../ActionButtons';

export const HandHeld = () => {
    const { screen } = useAppSelector(state => state.screenInteractions);

    return (
        <div className='box-shadow-light bg-black h-[92dvh] sm:h-full w-full sm:min-w-[400px]' style={{maxWidth: 400, maxHeight: 640, borderRadius: '16px 14px 8px 16px'}}>
            <div className="pixel-corners relative box-border p-3 h-full w-full green-gradient bg-green green-bg-gradient">
                <div className="pixel-corners h-full box-border flex flex-col bg-green-light border-green-light border-solid border-16">
                    <Screen />
                    <div className="flex flex-col justify-evenly relative">
                        <div className="flex justify-between items-center my-12 sm:px-4">
                            <DirectionalButtons/>
                            <ActionButtons/>
                        </div>
                        <OptionButtons screen={screen}/>
                    </div>
                    <WowBoiLogo />
                </div>
            </div>
        </div>
    )
}